module.exports = __webpack_public_path__ + "img/icon-1-3.72874101.png";